import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {ConfigGroup, isValidExternalId} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-config-group-inspector",
    templateUrl: "./config-group-inspector.component.html",
    styleUrl: "./config-group-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class ConfigGroupInspectorComponent extends BaseInspectorComponent<ConfigGroup> {
    readonly $isValidExternalId = signal(isValidExternalId)
}
